"use strict";

var _defineProperty = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$AWS_REGIONS_, _exports$AWS_REGION_M;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AWS_REGION_MARKETS = exports.AWS_REGIONS_MAP = exports.AwsShortRegions = exports.AwsRegions = void 0;

var country_code_1 = require("./country-code");

var AwsRegions;

(function (AwsRegions) {
  AwsRegions["AFS1"] = "af-south-1";
  AwsRegions["APE1"] = "ap-east-1";
  AwsRegions["APNE1"] = "ap-northeast-1";
  AwsRegions["APNE2"] = "ap-northeast-2";
  AwsRegions["APS1"] = "ap-south-1";
  AwsRegions["APSE1"] = "ap-southeast-1";
  AwsRegions["APSE2"] = "ap-southeast-2";
  AwsRegions["CAC1"] = "ca-central-1";
  AwsRegions["CN1"] = "cn-north-1";
  AwsRegions["EUC1"] = "eu-central-1";
  AwsRegions["EUN1"] = "eu-north-1";
  AwsRegions["EUS1"] = "eu-south-1";
  AwsRegions["EUW1"] = "eu-west-1";
  AwsRegions["EUW2"] = "eu-west-2";
  AwsRegions["EUW3"] = "eu-west-3";
  AwsRegions["SAE1"] = "sa-east-1";
  AwsRegions["USE1"] = "us-east-1";
  AwsRegions["USE2"] = "us-east-2";
  AwsRegions["USGE1"] = "us-gov-east-1";
  AwsRegions["USGW1"] = "us-gov-west-1";
  AwsRegions["USW1"] = "us-west-1";
  AwsRegions["USW2"] = "us-west-2";
})(AwsRegions = exports.AwsRegions || (exports.AwsRegions = {}));

var AwsShortRegions;

(function (AwsShortRegions) {
  AwsShortRegions["AFS1"] = "afs1";
  AwsShortRegions["APE1"] = "ape1";
  AwsShortRegions["APNE1"] = "apne1";
  AwsShortRegions["APNE2"] = "apne2";
  AwsShortRegions["APS1"] = "aps1";
  AwsShortRegions["APSE1"] = "apse1";
  AwsShortRegions["APSE2"] = "apse2";
  AwsShortRegions["CAC1"] = "cac1";
  AwsShortRegions["CN1"] = "cn1";
  AwsShortRegions["EUC1"] = "euc1";
  AwsShortRegions["EUN1"] = "eun1";
  AwsShortRegions["EUS1"] = "eus1";
  AwsShortRegions["EUW1"] = "euw1";
  AwsShortRegions["EUW2"] = "euw2";
  AwsShortRegions["EUW3"] = "euw3";
  AwsShortRegions["SAE1"] = "sae1";
  AwsShortRegions["USE1"] = "use1";
  AwsShortRegions["USE2"] = "use2";
  AwsShortRegions["USGE1"] = "usge1";
  AwsShortRegions["USGW1"] = "usgw1";
  AwsShortRegions["USW1"] = "usw1";
  AwsShortRegions["USW2"] = "usw2";
})(AwsShortRegions = exports.AwsShortRegions || (exports.AwsShortRegions = {}));

exports.AWS_REGIONS_MAP = (_exports$AWS_REGIONS_ = {}, _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.AFS1, AwsRegions.AFS1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APE1, AwsRegions.APE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APNE1, AwsRegions.APNE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APNE2, AwsRegions.APNE2), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APS1, AwsRegions.APS1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APSE1, AwsRegions.APSE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.APSE2, AwsRegions.APSE2), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.CAC1, AwsRegions.CAC1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.CN1, AwsRegions.CN1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUC1, AwsRegions.EUC1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUN1, AwsRegions.EUN1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUS1, AwsRegions.EUS1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUW1, AwsRegions.EUW1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUW2, AwsRegions.EUW2), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.EUW3, AwsRegions.EUW3), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.SAE1, AwsRegions.SAE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USE1, AwsRegions.USE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USE2, AwsRegions.USE2), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USGE1, AwsRegions.USGE1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USGW1, AwsRegions.USGW1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USW1, AwsRegions.USW1), _defineProperty(_exports$AWS_REGIONS_, AwsShortRegions.USW2, AwsRegions.USW2), _exports$AWS_REGIONS_);
exports.AWS_REGION_MARKETS = (_exports$AWS_REGION_M = {}, _defineProperty(_exports$AWS_REGION_M, AwsRegions.USE1, [country_code_1.IsoCountryCode2Char.CA, country_code_1.IsoCountryCode2Char.GB, country_code_1.IsoCountryCode2Char.CH, country_code_1.IsoCountryCode2Char.US, country_code_1.IsoCountryCode2Char.ZA]), _defineProperty(_exports$AWS_REGION_M, AwsRegions.EUC1, [country_code_1.IsoCountryCode2Char.DE]), _defineProperty(_exports$AWS_REGION_M, AwsRegions.APSE1, [country_code_1.IsoCountryCode2Char.NZ]), _exports$AWS_REGION_M);